import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { Menu } from "lucide-react";
import Logo from "@/components/common/Logo";

const SellerAuthHeader = () => {
  const location = useLocation();
  const isRegisterPage = location.pathname === "/seller/register";
  
  return (
    <header className="border-b border-border bg-godyspo-background pt-[env(safe-area-inset-top)]">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Logo size="medium" context="seller" />
        <div className="flex items-center gap-4">
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/buyer" className="text-gray-300 hover:text-godyspo-gold transition-colors">
              For Buyers
            </Link>
            <Link to="/blog" className="text-gray-300 hover:text-godyspo-gold transition-colors">
              Blog
            </Link>
            <Link to="/seller/faq" className="text-gray-300 hover:text-godyspo-gold transition-colors">
              FAQ
            </Link>
            <Link to="/contact" className="text-gray-300 hover:text-godyspo-gold transition-colors">
              Contact
            </Link>
            {isRegisterPage ? (
              <Link to="/seller/login" className="text-gray-300 hover:text-godyspo-gold transition-colors">
                Sign In
              </Link>
            ) : (
              <Link to="/seller/register">
                <Button className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90">
                  Start Free Trial
                </Button>
              </Link>
            )}
          </nav>

          {/* Mobile Dropdown Menu */}
          <div className="md:hidden">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90">
                  <Menu className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent 
                className="w-56 bg-background border-border z-50" 
                align="end"
              >
                <DropdownMenuItem asChild>
                  <Link to="/buyer" className="w-full cursor-pointer">
                    For Buyers
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/blog" className="w-full cursor-pointer">
                    Blog
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/seller/faq" className="w-full cursor-pointer">
                    FAQ
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/contact" className="w-full cursor-pointer">
                    Contact
                  </Link>
                </DropdownMenuItem>
                {isRegisterPage ? (
                  <DropdownMenuItem asChild>
                    <Link to="/seller/login" className="w-full cursor-pointer">
                      Sign In
                    </Link>
                  </DropdownMenuItem>
                ) : (
                  <DropdownMenuItem asChild>
                    <Link to="/seller/register" className="w-full cursor-pointer text-godyspo-gold">
                      Start Free Trial
                    </Link>
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SellerAuthHeader;
